<div
  class="relative flex max-w-[12vw] flex-col items-center justify-center gap-1.5 text-center"
  [attr.data-testid]="'cart-item-' + id()"
  [attr.data-test-product-name]="name()"
>
  <div
    class="relative h-[12vw] w-[12vw] rounded-lg"
    [style.backgroundColor]="productBackgroundColor() | contentBuilderColor"
  >
    @if (thumbnail()) {
      <img
        class="push-image h-full w-full rounded-lg bg-center object-cover"
        [src]="thumbnail()"
        alt="image"
      />
    }
    @if (!isAvailable() || hasProductToReplace()) {
      <div class="absolute inset-0 z-10 rounded-lg bg-black bg-opacity-50"></div>
    }
    @if (!isAvailable() || hasProductToReplace()) {
      <div
        class="absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2 transform rounded-lg bg-red-100 px-2 py-1 text-center text-xs font-medium text-red-600"
      >
        {{
          hasProductToReplace()
            ? ('kiosk-product-overview-cart-atom.product-to-replace' | translate)
            : ('kiosk-product-overview-cart-atom.not-available' | translate)
        }}
      </div>
    }
    <span
      data-testid="cart-item-quantity"
      [attr.data-test-quantity]="quantity()"
      class="absolute -top-2 right-3 flex h-6 w-6 items-center justify-center rounded-full text-center text-sm font-bold"
      [style.backgroundColor]="dotColor() | contentBuilderColor"
      [style.color]="dotTextColor() | contentBuilderColor"
      >x{{ quantity() }}</span
    >
  </div>
  <p
    class="w-[12vw] max-w-[12vw] truncate text-ellipsis break-words text-center text-xs font-semibold kiosk-xl:text-base"
    [style.color]="productTextColor() | contentBuilderColor"
  >
    {{ name() }}
  </p>
</div>
